import React from "react";
import ReactECharts from "echarts-for-react";
import ChartCard from "./ChartCard";


const axisNameColor = '#334155';
const completedBarColor = '#00ff88';
const pendingBarColor = '#b6c2bd';
const labelColor = '#475569'
const axisLineColor = '#7798c3b4'
const axisLineWidth = 2;
const legendLabelColor = '#777c83'

const LineChart = ({
    chartLabel,
    chartData = [],
    xField,
    yField,
    tooltipFields = [],
    lineColor = "#18B47E",
    height = 420,
    isDate = false,
    xAxisTitle = "",
    yAxisTitle = "",
    purpose = "",
    seriesLabel = "Value",
}) => {

    const graphData =
        chartData.length > 0 ? chartData : [];

    const labels = graphData.map((item) => {
        if (isDate) {
            return new Date(item[xField]).toLocaleDateString(
                "en-GB",
                {
                    day: "2-digit",
                    month: "short",
                }
            );
        }

        return item[xField];
    });

    const option = {
        tooltip: {
            trigger: "axis",
            formatter: (params) => {
                const item = graphData[params[0].dataIndex];
                let html = "";
                if (purpose) {
                    html += `<b>Purpose</b><br/>${purpose}<br/><br/>`;
                }
                html += `<b>${isDate
                    ? new Date(item[xField]).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                    })
                    : item[xField]
                    }</b><br/>`;

                html += `<b>${seriesLabel}</b> : ${item[yField]}<br/>`;
                tooltipFields.forEach((field) => {
                    let value = item[field.key];
                    if (
                        value &&
                        (field.key.toLowerCase().includes("date") ||
                            value.toString().includes("T"))
                    ) {

                        const date = new Date(value);
                        value = `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;

                    }

                    html += `<b>${field.label}</b> : ${value ?? "-"}<br/>`;

                });

                return html;

            },
        },

        legend: {
            show: true,
            top: 5,
            left: "center",
            data: [seriesLabel],
            textStyle: {
                fontSize: 12,
                fontWeight: 600,   // or 600, 700
                color: legendLabelColor,
            },
        },

        grid: {
            left: "8%",
            right: "4%",
            top: "8%",
            bottom: "12%",
            containLabel: true,
        },

        xAxis: {
            type: "category",
            name: xAxisTitle,
            nameLocation: "middle",
            nameGap: 35,
            data: labels,
            axisTick: {
                show: false,
            },
            nameTextStyle: {
                fontSize: 14,
                fontWeight: "bold",
                color: axisNameColor,
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: axisLineColor,
                    width: axisLineWidth,
                },
            },
            axisLabel: {
                show: true,
                color: labelColor,
                fontSize: 11,
                rotate: 20,
            },

            splitLine: {
                show: false,
            },
        },

        yAxis: {
            type: "value",
            name: yAxisTitle,
            nameLocation: "middle",
            nameGap: 45,
            splitLine: {
                lineStyle: {
                    color: "#ECECEC",
                },
            },
            nameTextStyle: {
                fontSize: 14,
                fontWeight: "bold",
                color: axisNameColor,
            },

            axisLine: {
                show: true,
                lineStyle: {
                    color: axisLineColor,
                    width: axisLineWidth,
                },
            },

            axisLabel: {
                show: true,
                color: labelColor,
                fontSize: 11,
                rotate: 0,

            }
        },

        series: [
            {
                name: seriesLabel,
                type: "line",
                smooth: true,
                data: graphData.map(
                    (item) => item[yField]
                ),
                symbol: "circle",
                symbolSize: 8,
                lineStyle: {
                    color: lineColor,
                    width: 3,
                },
                itemStyle: {
                    color: lineColor,
                },
                emphasis: {
                    focus: "series",
                },
            },
        ],
    };

    return (
        <ChartCard
            title={chartLabel}
            height={height}
        >
            <ReactECharts
                option={option}
                style={{
                    width: "100%",
                    height: "100%",
                }}
            />
        </ChartCard>
    );
};

export default LineChart;